export const selectLandingPage = store => store.landingPage;
